import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from 'react';
import {
  Row,
  Col,
  Select,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';

import {
  SpH5,
  SpError,
} from 'components/DesignKit';

const { Option } = Select;

type Props = {
  businessInfo: Object,
  bussinessChange: Function,
};

const BussinessType = (props: Props, ref) => {
  const {
    businessInfo,
    bussinessChange,
  } = props;

  const [, forceUpdate] = useState();
  const [bussinessType, setBussinessType] = useState(businessInfo?.bussinessType);
  const simpleValidator = useRef(new SimpleReactValidator());

  useImperativeHandle(ref, () => ({
    validate: () => {
      const formValid = simpleValidator.current.allValid();
      if (!formValid) {
        simpleValidator.current.showMessages();
        forceUpdate(1);
        return false;
      }
      businessInfo.bussinessType = bussinessType;
      return true;
    },
  }));

  return (
    <>
      <div>
        <Row>
          <Col span={6} className="mb-2">
            <SpH5>Choose Business Type</SpH5>
          </Col>
        </Row>
        <Row>
          <Col span={6}>
            <Select
              value={bussinessType}
              placeholder="Select"
              className="w-100"
              onChange={value => {
                setBussinessType(value);
                businessInfo.bussinessType = value;
                bussinessChange(value);
              }}
              showSearch
            >
              <Option key={1} value="RESTAURANT">Restaurant</Option>
              <Option key={2} value="Non-Profit">Non-Profit</Option>
            </Select>
            <SpError>
              {simpleValidator.current.message('business type', bussinessType, 'required')}
            </SpError>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default forwardRef(BussinessType);
